
export type HorizontalAlignmentPosition = 
  | 'stretch'
  | 'stretchTarget'
  | 'targetLeading'
  | 'targetTrailing'
  | 'targetCenter';